import ComparisonDetailPage from './Page';
export default ComparisonDetailPage;
